<div *ngIf="videoPlayerOptions">
  <app-video-player
    [options]="videoPlayerOptions"
    [poster]="asset?.posterUrl || 'assets/img/Nextgen_Rodeo-Icon.png'"
  ></app-video-player>
</div>
<div *ngIf="!videoPlayerOptions && !asset && !isLoading">
  Please check your streaming asset Id.
</div>
